// extracted by mini-css-extract-plugin
export default {"statsHeader":"ScoreboardHeader_statsHeader__ZnoDw","statsContainer":"ScoreboardHeader_statsContainer__uy8aw"};